import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


const BASEURL = environment.apiBase;

@Injectable({
  providedIn: 'root'
})
export class SpecialistsService {

  constructor(private http: HttpClient) { }

  public getPlansCoach(userId: string): Observable<any> {
    return this.http.get(`${BASEURL}/v3/follow-up/specialists/${userId}`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        //catchError(this.handleError<any>('login', []))
      );
  }

  public getSpecialists(): Observable<any> {
    return this.http.get(`${BASEURL}/v3/follow-up/specialists`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        //catchError(this.handleError<any>('login', []))
      );
  }

  public getCoachesToChange(): Observable<any> {
    return this.http.get(`${BASEURL}/v3/coaches`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        //catchError(this.handleError<any>('login', []))
      );
  }

  public getPublicCoaches(referenceCode?: string): Observable<any> {
    const params: any = referenceCode ? { reference_code: referenceCode } : {};

    return this.http.get(`${BASEURL}/v3/public_coaches`, {
      headers: {
        'Authorization': localStorage.getItem('token') || ''
      },
      params
    }).pipe(
      tap((response: any) => {
        // console.log(response);
      })
      // catchError(this.handleError<any>('getPublicCoaches', []))
    );
  }


  public changeCoach(coachId): Observable<any> {
    return this.http.put(`${BASEURL}/v3/coaches/${coachId}`, {}, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        //catchError(this.handleError<any>('login', []))
      );
  }

  public buyPlan(path: string): Observable<any> {
    return this.http.post(`${BASEURL}${path}`, {}, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        //catchError(this.handleError<any>('login', []))
      );
  }
}